@if (showDevAlert) {
  <app-alert text="{{ 'common.devNotice' | translate }}" type="warning" />
}
<div class="password-protection-wrapper cbw-password-protection-wrapper">
  @if (supportedWidgetLanguages?.length > 1 && langSwitcher) {
    <div ngbDropdown class="lang-dropdown-wrapper cbcw-lang-dropdown-wrapper">
      <button class="nav-link lang-dropdown" id="password-protection-lang-dropdown" ngbDropdownToggle>
        <span>
          @for (language of languages; track language) {
            @if (lang === language.locale) {
              <img width="20px" height="20px" (click)="switchLanguage(language.locale)" alt="{{ language.text }}" src="{{ deployUrl + language.flagIcon }}" />
            }
          }
        </span>
      </button>

      @if (supportedWidgetLanguages?.length > 1) {
        <div class="lang-dropdown-menu" ngbDropdownMenu aria-labelledby="password-protection-lang-dropdown">
          @for (language of languages; track language) {
            @if (lang !== language.locale && supportedWidgetLanguages && supportedWidgetLanguages.indexOf(language.value) > -1) {
              <a ngbDropdownItem class="lang-dropdown-menu-item" href="javascript:void(0)" (click)="switchLanguage(language.locale)">
                <span class="d-flex justify-content-center">
                  <img width="20px" height="20px" alt="{{ language.text }}" src="{{ deployUrl + language.flagIcon }}" />
                </span>
              </a>
            }
          }
        </div>
      }
    </div>
  }

  @if (isTemplateLoading) {
    <div class="password-protection skeleton-animation d-flex flex-column align-items-center">
      <div class="bar bar-1"></div>
      <div class="bar bar-2"></div>
      <div class="bar bar-3"></div>
      <div class="bar bar-4"></div>
      <div class="bar bar-5"></div>
    </div>
  } @else {
    <div class="password-protection cbw-password-protection">
      <div class="heading">
        <h1> {{ _widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PASSWORD_PROTECTION_TITLE, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}</h1>
        <p> {{ _widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PASSWORD_PROTECTION_DESCRIPTION, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}</p>
      </div>
  
      <div body class="custom-field form-group">
        @if (widgetConf?.widget_protection_type === widgetPasswordType.OTP) {
          @if (!isOtpSent) {
            <div class="p-3 otp-verification-info">
              <div class="fw-bold">
                @if (widgetConf?.otp_verification_type === otpVerificationType.EMAIL) {
                  {{ 'common.otp_will_be_sent_to' | translate: { recipient: customerEmail } }}
                } @else if (widgetConf?.otp_verification_type === otpVerificationType.SMS) {
                  {{ 'common.otp_will_be_sent_to' | translate: { recipient: customerMobile || customerPhone } }}
                }
              </div>
              <div>
                @if (widgetConf?.otp_verification_type === otpVerificationType.EMAIL) {
                  {{ 'common.ensure_you_have_access_to_your_email_to_receive_the_otp' | translate }}
                } @else if (widgetConf?.otp_verification_type === otpVerificationType.SMS) {
                  {{ 'common.ensure_you_have_access_to_your_mobile_to_receive_the_otp' | translate }}
                }
              </div>
              @if (isRateLimitError || errorMessage) {
                <div class="alert alert-danger summary-warning">
                  @if (errorMessage) {
                    {{ errorMessage | translate }}
                  } @else if (isRateLimitError) {
                    <ng-container *ngTemplateOutlet="rateLimitErrorTemplate" />
                  }
                </div>
              }
            </div>
            <div class="mt-3 action-button-section">
              <calenso-button
                type="primary"
                #button
                id="cbw-next-button"
                (clickEvent)="sendOtp()"
                [widgetColorConf]="widgetColorConf"
                placement="right"
                text="{{ 'common.send_otp' | translate }}"
                [isloading]="isSendOtpLoading"
                [disabled]="isSendOtpLoading"
              />
            </div>
          } @else {
            <div class="my-4 cbw-otp-section">
              <app-otp-input
                [length]="widgetConf?.otp_complexity === otpComplexity.LOW ? 4 : 6"
                [isPassword]="false"
                (otpChange)="updateOtp($event)"
                (otpEnterPress)="submitOtp()">
              </app-otp-input>
            </div>

            @if (isVerifyOtpLoading) {
              <div class="text-center">
                <div class="spinner-border" role="status"></div>
              </div>
            } @else if (invalidPassword || errorMessage || isRateLimitError) {
              <div class="alert alert-danger summary-warning text-center">
                @if (invalidPassword) {
                  {{ _widgetTemplates | calioMeetingTemplate: { id: templateConstant.OTP_VERIFICATION_TEXT_FAILED, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}
                } @else if (isRateLimitError) {
                  <ng-container *ngTemplateOutlet="rateLimitErrorTemplate" />
                } @else if (errorMessage) {
                  {{ errorMessage | translate }}
                } @else {
                  {{ 'error_messages.something_went_wrong' | translate }}
                }
              </div>
            }

            <!-- Timer and Retry Section -->
            <div class="otp-timer-retry-section mt-2 cbw-otp-timer-retry-section">
              @if (isOtpTimerActive) {
                <div class="otp-timer-info">
                  {{ 'common.resend_otp_available_in' | translate }} {{ getFormattedTimer() }}
                </div>
              } @else {
                <div class="otp-retry-section">
                  {{ 'common.didnt_receive_otp' | translate }}
                  <a class="cursor-pointer" (click)="sendOtp()">
                    {{ 'common.resend_otp' | translate }}
                  </a>
                </div>
              }
            </div>
          }
          @if (_widgetTemplates | calioMeetingTemplate: { id: templateConstant.OTP_VERIFICATION_HINT_TEXT, type: 'template' }) {
            <div class="alert alert-warning mt-3 mb-0 py-2" [innerHTML]="_widgetTemplates | calioMeetingTemplate: { id: templateConstant.OTP_VERIFICATION_HINT_TEXT, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang">
            </div>
          }
        } @else if (widgetConf?.widget_protection_type === widgetPasswordType.PASSWORD) {
          <label class="input-label mb-1" for="password" id="label_password">
            {{ _widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PASSWORD_PROTECTION_LABEL, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}
          </label>
          <input
            required="true"
            placeholder="{{ _widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PASSWORD_PROTECTION_PLACEHOLDER, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}"
            #password="ngModel"
            name="password"
            type="password"
            ngModel
            pattern=".*\S.*" 
            class="form-control cbw-input-field"
            (keyup.enter)="!password.invalid && submitPassword(password)"
          />
          @if (password.touched && password.invalid) {
            <div class="alert alert-danger summary-warning">
              @if (password.errors?.required) {
                {{ 'customer.customFields.error.required' | translate }}
              } @else if (password.errors?.pattern) {
                {{ 'common.empty_string_validation' | translate }}
              } 
            </div>
          }
          @if (invalidPassword) {
            <div class="alert alert-danger summary-warning">
              {{ 'common.invalid_password' | translate }}
            </div>
          }
          <div class="mt-3 action-button-section">
            <calenso-button
              type="primary"
              #button
              id="cbw-next-button"
              (clickEvent)="submitPassword(password)"
              [widgetColorConf]="widgetColorConf"
              placement="right"
              text="{{ _widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PASSWORD_PROTECTION_LOGIN_BUTTON_TEXT, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}"
              [isloading]="isVerifyPasswordLoading"
              [disabled]="isVerifyPasswordLoading"
            />
          </div>
        }
      </div>
    </div>
  }
</div>

<ng-template #rateLimitErrorTemplate>
  @if (blockForTimeMinutes) {
    <span [innerHTML]="('summary_page_translations.' + ((blockForTimeMinutes === 1) ? 'block_for_minute' : 'block_for_minutes') | translate : { time: blockForTimeMinutes } | trustHtml)"></span>
  } @else if (blockForTimeSeconds) {
    <span [innerHTML]="('summary_page_translations.' + ((blockForTimeSeconds === 1) ? 'block_for_second' : 'block_for_seconds') | translate : { time: blockForTimeSeconds } | trustHtml)"></span>
  } @else {
    <span [innerHTML]="('summary_page_translations.too_many_requests_exception' | translate | trustHtml)"></span>
  }
</ng-template>